import { useConfig } from 'domains/config/hooks'

export const useSeamlyAppContainerClassNames = () => {
  return useConfig().appContainerClassNames
}

export const useSeamlyMessageContainerClassNames = (event) => {
  const { fromClient } = event.payload
  const classNames = ['message']

  if (event.type === 'info') {
    classNames.push('message--source-info')
  } else if (!fromClient) {
    classNames.push('message--source-agent')
  } else {
    classNames.push('message--source-user')
  }

  return classNames
}
